<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "voimaa_pakaratreenilla_osa_1";
    let title = "Osaatko aktivoida pakaralihaksesi?";
    let author = "Mata";
    let blogDate = "11.2.2023";
    let titlePic = "2023/pihasavotta.jpg";
    let firstPara = "Pakaralihakset ovat ihmisen voimakkain lihasryhmä. Lue tästä, kuinka voit itse kokeilla osaatko aktivoida pakarasi.";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>

            <p>Pakaroiden treenaus on noussut viime aikoina trendiksi asti. Pakaroihin halutaan muotoa ja kokoa. 
                Pakaroilla on myös oikeasti merkitystä sekä terveyden että suorituskyvyn kannalta. 
                Pakaralihakset ovat meille suorastaan elintärkeät. Kun puhutaan pakaroista, on kyseessä itse 
                asiassa lihasryhmä. Sen tärkeimmät tehtävät ovat lantion ojennus, kierto ja loitonnus. </p>
            <p>Pakaralihakset ovat (tai ainakin niiden tulisi olla) ihmisen voimakkain lihasryhmä. Passiivinen 
                elämäntapa ja yksipuoliset treenitottumukset saattavat kuitenkin saada lihakset “uinumaan”. 
                Saliharjoittelussa tämä näkyy ongelmina hermotuksessa, vaikeuksina saada tuntumaa pakaroihin 
                ja kehityksen pysähtymisenä. Kehon suurimpana lihasryhmänä pakaran uinuminen muodostuu 
                pullonkaulaksi joka vaikuttaa kaikkeen kehitykseen.</p>
            <p>Tässä artikkelissa käymme läpi pakaroiden lihasten toimintaa sekä pohdimme mahdollisia syitä, 
                mikäli jalkatreeni ei tunnu pakaroissa ja miten sen saisi siellä tuntumaan. Käymme myös läpi 
                joitakin pakaran toimintahäiriöiden vaikutuksia liikkeeseen ja asennonhallintaan.</p>
                
            <h2>Pakara koostuu kolmesta lihaksesta</h2>


            <div class="row">
                <div class="col-xs-12 col-md-6 img_container">
                    <img class="img"
                         src='/svelte-site/img/blog/2023/Posterior_Hip_Muscles_3.png'
                         alt="Iso pakaralihas ja keskimmäinen pakaralihas. Lähde: Wikipedia">
                         <p class="kuvateksti">Iso pakaralihas ja keskimmäinen pakaralihas sijaitsevat uloimpana ja suurikokoisimpana ovat vahvimmat lonkan alueen lihaksista.</p>
                </div>
                <div class="col-xs-12 col-md-6 img_container">
                    <img class="img"
                         src='/svelte-site/img/blog/2023/Posterior_Hip_Muscles_1.png'
                         alt="Pieni pakaralihas ja kiertäjälihakset. Lähde: Wikipedia">
                         <p class="kuvateksti">Pieni pakaralihas sekä 6 pientä reiden kiertäjälihasta sijaitsevat syvemmällä lonkkanivelen ympärillä.</p>
                </div>
            </div>

<h3>Iso pakaralihas</h3>
<p>Iso pakaralihas (gluteus maximus) on nimensä mukaisesti suurin ja vahvin pakaran lihaksista. Se lähtee ristiluusta ja suoliluuharjnun takaosasta osittain kiinni reisiluun takayläpintaan ja sen yli sääriluuhun. Ison pakaralihaksen tärkein tehtävä on lonkan ojennus, ja se osallistuus myös lonkan ulkokiertoon.</p>

<h3>Pieni pakaralihas ja keskimmäinen pakaralihas </h3>
<p>Pienen pakaralihaksen (gluteus minimus) ja keskimmäisen pakaralihaksen (gluteus medius) tehtävänä on lantion asennon hallinta ja loitonnus. Tällä on merkitystä esimerkiksi kävelyssä ja juoksussa lantion tasapainottajana. Molemmat lihakset ylittävät lonkkanivelen lähtien suoliluuharjulta reiden yläosaan.</p>

<h2>Nukkuuko pakarasi?</h2>

<p>Pakaroiden aktivaatio vaikeutuu, jos arki koostuu pitkälti istumisesta ja pakarat toimivat lähinnä istuinpehmusteena. 
    Jos pakaroihin on vaikea saada “tunnetta” jalkatreeneissä ja kyykyt tuntuvat enemmän selässä ja etureisissä, voi olla että 
    kärsit nukkuvasta pakarasta. Runsas istuminen altistaa tälle. Kireät ja heikot takareidet sekä lonkankoukistajat sekä 
    pakaralihaksen passivoituminen venyneessä tilassa aiheuttaa sen, että pakara ei aktivoidu kuten sen pitäisi. Kyseessä 
    on sekä lihasvoiman että hermotuksen tila, joka on kuitenkin mahdollista korjata oikeanlaisella treenillä.</p>

<p>Varpaiden linjaus lähtee pakaroista. Sanotaan, että kyykätessä polvien tulisi olla varpaiden suuntaiset. Tarkemmin katsottuna, 
    polven tulisi linjata 2. varpaan päälle. Ylipronaatio eli painopisteen kääntyminen sisäänpäin on yleistä. Pakaran heikkous voi 
    johtaa supinaation puuttumisen ja ylipronaatioon sekä polvien kääntymiseen sisäänpäin, mikä aiheuttaa riskiä rasitusvammoille, 
    mutta korjautuu aktivoimalla pakarat. Voit itse kokeilla tätä aktivoimalla seisoma-asennossa pakarat ulkokiertoon. Mikäli 
    pakarat toimivat “oikein”, tapahtuu myös tämä aktivaatio helpommin.</p>

<h3>Näin testaat pakaralihastesi aktivaatiokyvyn</h3>

<p><strong>Keskimmäisen ja pienen pakaralihaksen toiminnan testaaminen:</strong></p>
<p>Seiso tasaisesti kahdella jalalla. Koukista toinen jalka ilmaan. Mikäli pystyt seisomaan tässä asennossa niin että lantion asento pysyy suorana, aktivoituvat lihakset oikein. Jos lantio keikahtaa, eivät lihakset aktivoidu riittävästi.</p>
<p><strong>Ison pakaralihaksen toiminnan testaaminen:</strong></p>
<p>Seiso tasaisesti kahdella jalalla. Laita käsi pakarasi päälle. Aktivoi pakarasi ensin yhtä aikaa, sitten vuorotellen. Tunnetko selvästi lihasten aktivoitumisen? Hyvä, silloin iso pakaralihaksesi aktivoituu oikein. </p>
<p>Nyrkkisääntönä: Jos haluat treenata tehokkaasti pakaroitasi, tee moninivelliikkeitä. Mutta mikäli kärsit nukkuvien pakaroiden syndroomasta, ota mukaan eristäviä kohdeliikkeitä jotta löydät ja opit aktivoimaan oikeat lihakset.</p>
<p>Artikkelisarjan seuraavissa osissa käymme läpi pakaroihin kohdistuvia liikkeitä tarkemmin.</p>
</article>
    
        

<section class="container">
    <h2>Lue seuraavaksi</h2>
    <div class="row">
        <article class="blog col-xs-12 col-md-4">
            <BlogSummary blogPath='voimaa_pakaratreenilla_osa_2' title='Parhaat liikkeet pakaratreeniin' titlePic='2023/suorinjaloinmave1.jpg' blogDate='' firstPara='Pakara-artikkelien toisessa osassa käymme läpi parhaat liikkeet pakaralihasten voiman kasvattamiseen.'></BlogSummary>
        </article>
        <article class="blog col-xs-12 col-md-4">
            <BlogSummary blogPath='kyykkya-joka-paiva' title='Kyykkyä joka päivä - 26 päivää' titlePic='kyykky-800x787.jpg' blogDate='' firstPara='Levytangolla tehtävistä kyykkyliikkeistä etu- ja takakyykky ovat ne tunnetuimmat ja tehokkaimmat versiot. Olen viimeisinä vuosina yrittänyt tehdä selkäni vuoksi enemmän etukyykkyä kuin takakyykkyä, sillä etukyykky on selälle kevyempi vaihtoehto.'></BlogSummary>
        </article>
        <article class="blog col-xs-12 col-md-4">
            <BlogSummary blogPath='selkavaivat_kuriin_treenaamalla' title='Selkävaivaisena treenaamisesta' blogDate='' 
            titlePic='2014/levytanko.jpg' firstPara='Selkävaivat ovat nykyisin valitettavan yleisiä. Tilastojen mukaan vähintään joka kolmas suomalainen sanoo kärsineensä selkävaivoista viimeisen puolen vuoden aikana. Yleisimmit kivut esiintyvät alaselän alueella.'></BlogSummary>
        </article>
    </div>
</section>

    
</div>
{/if}

<style>

.img_container {
    background-color:#fff;
    margin:20px;
    max-width: 360px;
}
.img_container img {
    background-color:#fff;
    margin:20px 0;
    max-width: 100%;
}

</style>
